// =============================
// SECTION DIVIDER COMPONENT
// =============================

import "./Divider.css";

export default function Divider() {
    return (
        <div className="divider-wrapper">
            <div className="divider-line" />

            <div className="divider-text">
                <span>
                    HACK KRMU 5.0 • HACK KRMU 5.0 • HACK KRMU 5.0 • HACK KRMU 5.0 •
                    HACK KRMU 5.0 • HACK KRMU 5.0 •
                </span>
                <span>
                    HACK KRMU 5.0 • HACK KRMU 5.0 • HACK KRMU 5.0 • HACK KRMU 5.0 •
                    HACK KRMU 5.0 • HACK KRMU 5.0 •
                </span>
                <span>
                    HACK KRMU 5.0 • HACK KRMU 5.0 • HACK KRMU 5.0 • HACK KRMU 5.0 •
                    HACK KRMU 5.0 • HACK KRMU 5.0 •
                </span>
                <span>
                    HACK KRMU 5.0 • HACK KRMU 5.0 • HACK KRMU 5.0 • HACK KRMU 5.0 •
                    HACK KRMU 5.0 • HACK KRMU 5.0 •
                </span>
            </div>
        </div>
    );
}
